import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import { Http } from "@status/codes";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";

import {
  SPACES_ACCESS,
  SPACE_CONSTANTS,
  SPACE_FILTERS
} from "@/modules/Space/constants/SpaceConstants";
import { SpaceService } from "./services/SpaceService";
import { SpacePagination } from "./models/SpacePagination";
import { SpaceHeader } from "./models/SpaceHeader";
import { Response } from "@/shared/models/Response";
import { SpaceQuery } from "./models/SpaceQuery";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import store from "@/store";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { Utils } from "@/shared/utils/utils";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import lodash from "lodash";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";

@Component({
  name: "Space",
  components: {
    EmptyState,
    ScrollBottom,
    ObservationModal,
    ModalTemplate,
    ListItem,
    GenericSearchBar
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Space extends Vue {
  @Inject() spaceService!: SpaceService;

  dataToMainView!: MenuDataStructure;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  PAGE_TITLE = SPACE_CONSTANTS.PAGE_TITLE_SEARCH;
  ADD_SPACE_BTN = SPACE_CONSTANTS.BUTTON.ADD_SPACE;
  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  OPERATIONS: string[] = [];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  SEARCH_SPACE_KEY = NAME_FINDERS.SPACE;

  showCardsContainer = false;
  loadingData = false;
  spaceList!: SpaceHeader[];
  dataSpace!: Response<SpacePagination>;
  campusName = "";
  idReference = "";
  canSearch = true;
  viewDialog = false;
  showButtonCreate = false;

  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};

  filterItems: {
    name?: string[];
    state?: string[];
  } = {};
  filterArray: Filter[] = lodash.cloneDeep(SPACE_FILTERS) as Filter[];

  admin = false;

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL
    ) {
      this.callbackHandleContextPanel = this.dataToMainView.data;
    }
  }

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.SPACE
    );
    this.searchData(true);
    this.emitModalInitializer();
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    this.showButtonCreate = this.OPERATIONS.includes(
      LIST_DATA_EVENTS.SAVE_DATA
    );
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  emitModalInitializer() {
    const searchContext: SearchContextModal = {
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.SPACE
    };
    const data = {
      ...searchContext
    };
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL, data);
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editSpace(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteSpace(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateSpace(itemId, STATE.ACTIVE);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateSpace(itemId, STATE.INACTIVE);
        break;
    }
  }

  async updateStateSpace(id: string, state: string) {
    try {
      const responseData = await this.spaceService.updateStateSpaceById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(SPACE_CONSTANTS.DIALOG_MESSAGE.UPDATE);
        await this.searchData(true);
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SPACES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  editSpace(sessionId: string) {
    NavigationService.navigateTo(SystemView.SAVE_SPACE, {
      id: sessionId
    });
  }

  async searchData(data: any) {
    this.loadingData = true;
    this.showCardsContainer = false;
    this.canSearch = false;
    this.spaceList = [];

    delete data["mainFilterKey"];

    this.filterItems = { ...data };

    this.dataSpace = await this.getDataByFilter();

    if (
      this.dataSpace.code === Http.Found &&
      this.dataSpace.data !== undefined
    ) {
      this.spaceList = this.dataSpace.data.spaces;
      this.idReference = this.dataSpace.data.docref;
      this.showCardsContainer = true;
      this.canSearch = true;
    } else {
      if (this.dataSpace.code === Http.NotFound) {
        Snackbar.popInfo(this.dataSpace.message);
      } else {
        Snackbar.popError(this.dataSpace.message);
      }
    }

    this.loadingData = false;
  }

  async getDataByFilter(
    loadPages?: boolean
  ): Promise<Response<SpacePagination>> {
    try {
      const filterQuery: SpaceQuery = {
        state: [STATE.ACTIVE]
      };

      if (this.filterItems.name) filterQuery.name = this.filterItems.name[0];

      if (this.filterItems.state) filterQuery.state = this.filterItems.state;

      if (loadPages) filterQuery.docref = this.idReference;

      const responseData = await this.spaceService.getSpaceByFilter(
        filterQuery
      );
      return responseData;
    } catch (error) {
      const RESPONSE_ERROR: Response<SpacePagination> = {
        code: Http.BadRequest,
        message:
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SPACES_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED
      };
      return RESPONSE_ERROR;
    }
  }

  async deleteSpace(id: string) {
    try {
      const responseData = await this.spaceService.deleteSpace(id);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(SPACE_CONSTANTS.DIALOG_MESSAGE.DELETED);
        await this.searchData(true);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(SPACE_CONSTANTS.MESSAGE.SPACE_USED);
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData) {
      this.loadingData = true;
      this.dataSpace = await this.getDataByFilter(true);

      if (
        this.dataSpace.code === Http.Found &&
        this.dataSpace.data !== undefined
      ) {
        if (this.dataSpace.data.docref !== this.idReference) {
          this.spaceList = this.spaceList.concat(this.dataSpace.data.spaces);
          this.idReference = this.dataSpace.data.docref;
        } else {
          this.canSearch = false;
        }
      } else if (this.dataSpace.code === Http.NotFound) {
        this.canSearch = false;
      } else {
        Snackbar.popError(this.dataSpace.message);
        this.canSearch = false;
      }
    }
    this.loadingData = false;
  }

  showCrudSave() {
    NavigationService.navigateTo(SystemView.SAVE_SPACE);
  }
}
